module.exports = __webpack_public_path__ + "static/media/arrow-down.daee0d60.svg";